import { render, staticRenderFns } from "./EditTrainingsPage.vue?vue&type=template&id=07c67ef0&scoped=true&"
import script from "./EditTrainingsPage.vue?vue&type=script&lang=js&"
export * from "./EditTrainingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c67ef0",
  null
  
)

export default component.exports